"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUTRITIONAL_INFO_PER_SERVING = exports.SERVING_SIZE = void 0;
const Nutrition = __importStar(require("../../../../../../../nutrition"));
const Unit = __importStar(require("../../../../../../../unit"));
const mix_ratio_1 = require("../../enhancement/mix-ratio");
const style_1 = require("../../enhancement/style");
const common_1 = require("../common");
exports.SERVING_SIZE = Unit.Volume.UsFluidOunce.make({ amount: 12 });
// per 12 oz of water @ 100:1
exports.NUTRITIONAL_INFO_PER_SERVING = Nutrition.make({
    micro: {
        sodium: Unit.Mass.Milligram.make({ amount: 72 }),
        potassium: Unit.Mass.Milligram.make({ amount: 20 }),
        magnesium: Unit.Mass.Milligram.make({ amount: 5 }),
    },
});
exports.default = {
    ...common_1.SENSIENT_1500_ML_BIB_RANGE,
    _tag: 'LiquidEnhancement',
    id: 'electrolytes',
    name: 'Electrolytes',
    description: 'Revitalize with this premium electrolyte blend, ' +
        'crafted to effortlessly refresh and replenish your body ' +
        'whether you are staying active or recovering, ' +
        'this boost will prepare you to tackle any challenge.',
    flavored: false,
    flavor: ' ',
    nominalMixRatio: common_1.SENSIENT_NOMINAL_MIX_RATIO,
    mixRatioScalars: mix_ratio_1.MixRatioScalars.make([
        0.8, // 125:1
        1, // 100:1
        2, // 50:1
    ]),
    tags: [],
    nutritionalInfo: Nutrition.scale(exports.NUTRITIONAL_INFO_PER_SERVING, Nutrition.makeScalar(exports.SERVING_SIZE, common_1.SENSIENT_NOMINAL_MIX_RATIO)),
    ingredients: [
        'Treated Water',
        'Sodium Citrate',
        'Salt',
        'Citric Acid',
        'Magnesium Sulfate',
        'Dipotassium Phosphate',
        'Sodium Benzoate',
        'Potassium Sorbate (as preservatives)',
        'Natural Flavors',
    ],
    supplier: 'Essential Flavors & Fragrances, Inc.',
    formulationDate: '2026-03-05T00:00:00.000Z',
    style: {
        colors: style_1.PELICAN_FUNCTIONAL_ENHANCEMENT_STYLE_COLORS,
        coverImage: 'https://cgwiotstcfsprd.blob.core.windows.net/public/one-tool/consumableSubset/electrolytes.svg',
    },
};
//# sourceMappingURL=electrolytes.js.map